import { PriceComponent, PriceComponentWithCurrency, StatusComponent } from "components/Table/CellComponents";
import {
  openAccountingDrawer,
  openChequeDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer
} from "helpers/DrawerActions";
import { apiGetAccountCard, apiGetFactorWithDetailExcel, apiGetPersonAccountCardBills, apiGetPersonAccountCardCheques, apiGetPersonAccountCardFactors } from "../api/reportApi";
import { searchType } from "./FactorForm";

const PACTransactionsColumns = [
  {
    name: "تاریخ",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date"
    },
    searchType: "date"
  },
  {
    name: "شرح",
    key: "description",
    filterParams: {
      column: "description",
      columnType: "string"
    },
    clickable: (item: any) => true,
    onClick: (dispatch: any, item: any) => {
      if (item.type && item.type_id) {
        if (item.type === "factor") {
          openFactorDrawer(dispatch, item);
        } else if (item.type === "transaction") {
          openTransactionDrawer(dispatch, item);
        } else if (item.type === "transfer") {
          openTransferDrawer(dispatch, item);
        } else if (item.type === "bill") {
          openRemittanceDrawer(dispatch, item);
        }
      } else {
        openAccountingDrawer(dispatch, item);
      }
    }
  },
  {
    name: "بدهکار",
    key: "debtor",
    filterParams: {
      column: "debtor",
      columnType: "number"
    },
    price: true,
    // @ts-ignore
    // getValue: (item) => {
    //     return !item.isCreditor ? item.amount : "-";
    // },
    Component: PriceComponentWithCurrency,
    searchType: "quantitative"
  },
  {
    name: "بستانکار",
    // @ts-ignore
    // getValue: (item, all) => {
    //     return item.isCreditor ? item.amount : "-";
    // },
    key: "creditor",
    filterParams: {
      column: "creditor",
      columnType: "number"
    },
    price: true,
    Component: PriceComponentWithCurrency,
    searchType: "quantitative"
  },
  {
    name: "تراز",
    // getValue: (item: any, all: any[]) => {
    //     let key = 0;
    //     let balance = 0;
    //     const index = all?.findIndex((object) => object.id === item.id);
    //     while (key <= index) {
    //         const currentItem = all[key];
    //         balance += currentItem.isCreditor ? currentItem.amount : 0;
    //         balance -= !currentItem.isCreditor ? currentItem.amount : 0;
    //         key += 1;
    //     }
    //     return Math.abs(balance);
    // },
    Component: PriceComponent,
    key: "balance",
    filterParams: {
      column: "balance",
      columnType: "number"
    },
    price: true,
    searchType: "quantitative"
  },
  {
    name: "تشخیص",
    key: "status",
    disableSearch: true
  }
];
const PACFactorColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    getValue: (item: any) => item?.product?.accountingCode,
    filterParams: {
      column: "accountingCode",
      columnType: "string"
    }
  },
  {
    name: "کالا",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string"
    },
    getValue: (item: any) => item?.product?.title,
    navigateKey: (item: any) => item.productId,
    navigate: "/reports/productsAccountCard?productId="
  },
  {
    name: "تعداد خرید",
    key: "buyProductsQuantity",
    filterParams: {
      column: "productBuyCount",
      columnType: "number"
    },
    searchType: "quantitative"
  },
  {
    name: "تعداد فروش",
    key: "saleProductsQuantity",
    filterParams: {
      column: "productSellCount",
      columnType: "number"
    },
    searchType: "quantitative"
  },
  {
    name: "مبلغ خرید",
    key: "buyAmount",
    filterParams: {
      column: "productBuyAmount",
      columnType: "number"
    },
    price: true,
    Component: PriceComponent,
    searchType: "quantitative"
  },
  {
    name: "مبلغ فروش",
    key: "saleAmount",
    filterParams: {
      column: "productSellAmount",
      columnType: "number"
    },
    price: true,
    Component: PriceComponent,
    searchType: "quantitative"
  }
];
const PACChequeColumns = [
  {
    name: "شماره",
    key: "number",
    filterParams: {
      column: "number",
      columnType: "string"
    },
    clickable: () => true,
    onClick: (dispatch: any, item: any) => {
      openChequeDrawer(dispatch, item);
    }
  },
  {
    name: "تاریخ",
    key: "createdAt",
    filterParams: {
      column: "createdAt",
      columnType: "date"
    },
    searchType: "date"
  },
  {
    name: "مبلغ",
    key: "amount",
    filterParams: {
      column: "amount",
      columnType: "number"
    },
    price: true,
    Component: PriceComponent,
    searchType: "quantitative"
  },
  {
    name: "بانک",
    key: "bank",
    filterParams: {
      column: "bank",
      columnType: "string"
    }
  },
  {
    name: "شعبه",
    key: "branch",
    filterParams: {
      column: "branch",
      columnType: "string"
    }
  },
  {
    name: "وضعیت",
    key: "status",
    Component: StatusComponent
  }
];
const PACBillColumns = [
  {
    name: "تاریخ",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date"
    },
    searchType: "date"
  },
  {
    name: "مقدار",
    key: "quantity",
    filterParams: {
      column: "quantity",
      columnType: "number"
    },
    searchType: "quantitative"
  },

  {
    name: "شرح",
    key: "description",
    filterParams: {
      column: "date",
      columnType: "string"
    }
  },
  {
    name: "انبار",
    key: "warehouse",
    filterParams: {
      column: "date",
      columnType: "string"
    }
  },
  {
    name: "شعبه",
    key: "branch",
    searchKey: "title",
    getValue: (item:any) => {
      return item.branch ?? "-";
    },
    filterParams: {
      column: "BranchId",
      columnType: "string",
      relationModelName: "Branch",
      relationColumn: "title",
    },
    searchType: "autocomplete",
    dataKey: {
      column: "branches",
      key: "title",
    },
  },
    {
          name: "پروژه",
          key: "project",
          searchKey: "title",
          getValue: (item:any) => {
            return item.project ?? "-";
          },
          filterParams: {
            column: "ProjectId",
            columnType: "string",
            relationModelName: "Project",
            relationColumn: "title",
          },
          searchType: searchType.autocomplete,
          dataKey: {
            column: "projects",
            key: "title",
          },
        },
];

export const personalAccountCardIndexData = [
  {
    pageTitle: "کارت حساب اشخاص",
    personInfo: true,
    key: "personAccountTransactions",
    apiKey: "transactions",
    pluralLabel: "تراکنش ها",
    title: "تراکنش ها",
    tableColumns: PACTransactionsColumns,
    actions: {
      fetch: apiGetAccountCard,
      back: {},
      export: apiGetFactorWithDetailExcel

    }
  },
  {
    pageTitle: "کارت حساب اشخاص",
    key: "personAccountFactors",
    apiKey: "factors",
    label: "خرید و فروش کالا",
    pluralLabel: "خرید و فروش کالا",
    title: "خرید و فروش کالا",
    tableColumns: PACFactorColumns,
    actions: {
       fetch: apiGetPersonAccountCardFactors,
      back: {},
      export: apiGetFactorWithDetailExcel

    }
  },
  {
    pageTitle: "کارت حساب اشخاص",
    key: "personAccountCheques",
    apiKey: "cheques",
    label: "چک ها",
    pluralLabel: "چک ها",
    title: "چک ها",
    tableColumns: PACChequeColumns,
    actions: {
      fetch: apiGetPersonAccountCardCheques,
      back: {},
      export: apiGetFactorWithDetailExcel

    }
  },
  {
    pageTitle: "کارت حساب اشخاص",
    key: "personAccountBill",
    apiKey: "Bill",
    label: "حواله ها",
    pluralLabel: "حواله ها",
    title: "حواله ها",
    tableColumns: PACBillColumns,
    actions: {
      fetch: apiGetPersonAccountCardBills,
      back: {},
      export: apiGetFactorWithDetailExcel

    }
  }
];
